import React from 'react'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  onSearch: () => void
  placeholder: string
  dataDm?: string
}

export function SearchInput({ value, onChange, onSearch, placeholder, dataDm }: SearchInputProps) {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch()
    }
  }

  const handleIconClick = () => {
    if (value) {
      onSearch()
    }
  }

  return (
    <div className="cmp-search-job-redirect__input-group">
      <span 
        className={`cmp-search-job-redirect__search-icon icon--md icon-search ${value ? 'cmp-search-job-redirect__search-icon--active' : ''}`}
        onClick={handleIconClick}
        role={value ? 'button' : undefined}
        tabIndex={value ? 0 : -1}
        aria-label="Search"
      />
      <input
        type="text"
        className="cmp-search-job-redirect__search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        aria-label={placeholder}
        data-dm={dataDm || null}
      />
    </div>
  )
}

